import { render, staticRenderFns } from "./VInputCounter.vue?vue&type=template&id=b1c6403c&"
import script from "./VInputCounter.vue?vue&type=script&lang=ts&"
export * from "./VInputCounter.vue?vue&type=script&lang=ts&"
import style0 from "./VInputCounter.vue?vue&type=style&index=0&id=b1c6403c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports